define.alias("shared/components/shared/ui/list-uploaded-items", "media/components/shared/ui/list-uploaded-items");